import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card card-custom mb-5 mb-xxl-8" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = { class: "symbol symbol-50px me-5" }
const _hoisted_5 = { class: "symbol-label bg-light-success" }
const _hoisted_6 = { class: "svg-icon svg-icon-2x svg-icon-success" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "fs-4 text-gray-800 text-hover-primary fw-bolder"
  }, "Library Studio"),
  /*#__PURE__*/_createElementVNode("div", { class: "fs-7 text-muted fw-bold mt-1" }, "VueJS, Laravel")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder text-muted pt-7" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d-block fs-6" }, "26 Authors"),
  /*#__PURE__*/_createElementVNode("span", { class: "d-block pt-2 fs-6" }, "140 Comments")
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "progress h-6px bg-light-success mt-7" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "progress-bar bg-success",
    role: "progressbar",
    style: {"width":"80%"},
    "aria-valuenow": "50",
    "aria-valuemin": "0",
    "aria-valuemax": "100"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/abstract/abs027.svg" })
            ])
          ])
        ]),
        _hoisted_7
      ]),
      _hoisted_8,
      _hoisted_9
    ])
  ]))
}